import { render, staticRenderFns } from "./WagonWheelsetFileInput.vue?vue&type=template&id=25d33b08&scoped=true"
import script from "./WagonWheelsetFileInput.vue?vue&type=script&lang=js"
export * from "./WagonWheelsetFileInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d33b08",
  null
  
)

export default component.exports